export const externalLinks = {
    facebook: 'https://www.facebook.com/LeapstepFoundation',
    twitter: "https://twitter.com/LeapstepFoundation",
    instagram: "https://www.instagram.com/leapstep_foundation/" 
}